/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Lib dependencies
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

// UI lib dependencies
import {
	Select as NativeSelect,
	Image,
} from '@mantine/core';

// Styles
import classes from './SelectV2.module.css';

// Icons
import ArrowDownIcon from '@assets/icons/arrow-down.svg';

// Types
import { TSelectV2Props, TSelectOptions } from './type';
import { IconX } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const SelectV2 = (props: TSelectV2Props) => {
	const { data, onChange, ...restProps } = props;

	/* ********************************** HOOKS ********************************* */

	// I18n
	const { t } = useTranslation();
	const [value, setValue] = useState<string | null>('');
	/* **************************** RENDERING HELPERS *************************** */
	const renderUpdatedOptions = useCallback(
		(options: any) =>
			options.reduce(
				(
					acc: TSelectOptions[],
					currentItem: TSelectOptions
				) => {
					const modifiedItem = {
						...currentItem,
						label: t(currentItem.label),
					};
					acc.push(modifiedItem);
					return acc;
				},
				[]
			),
		[data]
	);

	/* ******************************** RENDERING ******************************* */
	return (
		<NativeSelect
			classNames={{
				input: classes.customDashboardInput,
				option: classes.customDashboardOption,
				dropdown: classes.dropdown,
			}}
			checkIconPosition="left"
			withScrollArea={false}
			searchable
			nothingFoundMessage="Nothing found..."
			value={value}
			rightSection={
				value ? (
					<IconX
						size={18}
						style={{
							display: 'block',
							opacity: 0.5,
							cursor: 'pointer',
						}}
						onClick={() => {
							setValue(null);

							if (onChange)
								onChange(null, { label: '', value: '' });
						}}
					/>
				) : (
					<Image
						className={classes.arrowDown}
						src={
							props.withoutrightsection
								? null
								: ArrowDownIcon
						}
					/>
				)
			}
			data={renderUpdatedOptions(data)}
			{...restProps}
			onChange={(_value, option) => {
				setValue(_value);
				if (onChange) onChange(_value, option);
			}}
		/>
	);
};
